import { features } from '@/mocks/comics';

export default function FeatureGrid() {
  return (
    <section className="w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-14">
          <div className="lg:flex-1">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4 font-label">
              为什么选择我们
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight">
              极致阅读体验
              <br />
              从这里开始
            </h2>
          </div>
          <div className="lg:flex-1 lg:pt-2">
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-md">
              我们致力于为漫画爱好者提供最佳的下拉式阅读体验。完整版、无删减、零门槛，让每一位读者都能畅享韩国漫画的魅力。
            </p>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-background-100 rounded-xl p-6 md:p-7 hover:bg-background-200/70 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-2.5">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}